import React from 'react'
import './SearchPageBodySidebarRight.css'

function SearchPageBodySidebarRight() {
    return (
        <div className="SearchPageBodySidebarRight">
            
        </div>
    )
}

export default SearchPageBodySidebarRight
